import React from "react";
import { useSelector } from "react-redux";
import { TranslationText } from "components/TextTranslationContainer";
import { PriceRender } from "components/DisplayPrice";

const LoyaltyRedeemSwitch = ({
  switchLoyaltyStatus,
  redeemAmount,
  // When set, the row is rendered disabled with this reason instead of being
  // hidden, so the customer is told why loyalty cannot be used. Callers that
  // leave it unset keep the previous behaviour of hiding an empty row.
  unavailableReason = null,
  wrapperStyleProps = {},
  labelStyleProps = {},
  switchStyleProps = {},
  thumbStyleProps = {},
  textStyleProps = {},
}) => {
  const loyaltyApplied = useSelector(
    (state) => state?.Loyalty?.loyaltyApplied
  );

  const isUnavailable = !!unavailableReason;

  if (!isUnavailable && Number(redeemAmount) <= 0) return null;

  // Always reflect the stored selection, even while the row is disabled: during
  // the balance load the customer may already have loyalty applied, and showing
  // the toggle off would misreport what the order will carry.
  const isOn = !!loyaltyApplied;

  return (
    <div
      className={`flex items-center ${
        wrapperStyleProps?.className || "rounded-lg bg-gray-100  mx-4 py-3 px-2"
      } ${isUnavailable ? "opacity-50 cursor-not-allowed" : ""}`}
      style={wrapperStyleProps?.style}
    >
      <label
        className={`flex items-center ${
          isUnavailable ? "cursor-not-allowed" : "cursor-pointer"
        } ${labelStyleProps?.className || ""}`}
        style={labelStyleProps?.style}
      >
        <div className="relative">
          <input
            type="checkbox"
            className="sr-only"
            checked={isOn}
            disabled={isUnavailable}
            onChange={isUnavailable ? () => {} : switchLoyaltyStatus}
          />
          <div
            className={`w-12 h-6 rounded-full transition-colors ${
              isOn ? "bg-brand-base-primary" : "bg-gray-300"
            } ${switchStyleProps?.className || ""}`}
            style={switchStyleProps?.style}
          />
          <div
            className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${
              isOn ? "right-1" : "left-1"
            } ${thumbStyleProps?.className || ""}`}
            style={thumbStyleProps?.style}
          />
        </div>
      </label>
      <div
        className={
          textStyleProps?.className || "flex gap-1 flex-wrap text-[15px] text-black"
        }
        style={textStyleProps?.style}
      >
        {isUnavailable ? (
          <TranslationText text={unavailableReason} />
        ) : (
          <>
            <TranslationText text={"Use your loyalty balance to get"} />
            <PriceRender
              price={redeemAmount}
              className="text-brand-base-primary"
            />
            <TranslationText text={"off"} />
          </>
        )}
      </div>
    </div>
  );
};

export default LoyaltyRedeemSwitch;
